import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { EnvironmentService } from '../../service/service.module';

@Injectable({ providedIn: 'root' })
export class MappingService {
  environment = EnvironmentService.environment;

  // Subjects
  addEditMappingActionSubject: Subject<boolean> = new Subject();

  /* Set Subjects for HEADER COLUMN EDIT/REMOVE */

  // Observables

  constructor(private http: HttpClient) {
  }

  GetCalendarList(body: any) {
    return this.http.post(`${this.environment.ForecastMapping}/GetCalendarList`, body)
      .pipe(map(response => {
        return response;
      }));
  }

  GetLookupItemsList() {
    return this.http.get(`${this.environment.MappingManager}/itemgetlist`)
      .pipe(map((response: any) => {
        return response;
      }));
  }

  CheckOverlapWeek(body: any = {}) {
    return this.http.post(`${this.environment.MappingManager}/getoverlapweek`, body)
      .pipe(map((response: any) => {
        return response;
      }));
  }

  MappingItemGetList() {
    return this.http.get(`${this.environment.MappingManager}/mappingItemGetList`)
      .pipe(map((forecastitemlist: any) => {
        return forecastitemlist;
      }));
  }

  GetMappingHitory(body: any) {
    return this.http.post(`${this.environment.MappingManager}/mappinghistorygetlist`, body)
      .pipe(map((forecastitemlist: any) => {
        return forecastitemlist;
      }));
  }

  GetWeeklyMappingSaleUnit(body: any) {
    return this.http.post(`${this.environment.MappingManager}/mappingSaleUnitList`, body)
      .pipe(map((forecastsaleunits: any) => {
        return forecastsaleunits;
      }));
  }

  UpdateForecastItemStatus(body: any) {
    return this.http.put(`${this.environment.MappingManager}/activate`, body)
      .pipe(map((forecastitem: any) => {
        return forecastitem;
      }));
  }

  AddForecastItem(body: any = {}) {
    return this.http.post(`${this.environment.MappingManager}/addforecastitem`, body)
      .pipe(map((forecastitem: any) => {
        return forecastitem;
      }));
  }

  UpdateForecastItem(body: any = {}) {
    return this.http.put(`${this.environment.MappingManager}/update`, body)
      .pipe(map((forecastitem: any) => {
        return forecastitem;
      }));
  }

  DeleteForecastItem(body: any) {
    return this.http.post(`${this.environment.MappingManager}/delete`, body)
      .pipe(map((forecastitemlist: any) => {
        return forecastitemlist;
      }));
  }

  DeleteMappedItem(mappedItemId: any, retailerKey: any, sku: any) {
    return this.http.delete(`${this.environment.MappingManager}/deletemappeditem?mappedItemId=${mappedItemId}&retailer=${retailerKey}&sku=${sku}`)
      .pipe(map((response: any) => {
        return response;
      }));
  }

  MappingSourceByMappingManagerId(mappingManagerId: any) {
    return this.http.get(`${this.environment.MappingManager}/mappingSourceByMappingManagerId?MappingManagerId=${mappingManagerId}`)
      .pipe(map((mappeditemlist: any) => {
        return mappeditemlist;
      }));
  }

  GetAvgWeeklySaleUnit(body: any) {
    return this.http.post(`${this.environment.MappingManager}/getavgweeklysaleunit`, body)
      .pipe(map((mappedItems: any) => {
        return mappedItems;
      }));
  }

  TriggerMappingManagerPipeline(body: any = {}) {
    return this.http.post(`${this.environment.MappingManager}/pipeline`, body)
      .pipe(map((response: any) => {
        return response;
      }));
  }

  AzurePipelineTriggerGetList(body: any = {}) {
    return this.http.get(`${this.environment.MappingManager}/AzurePipelineTriggerGetList`)
      .pipe(map((azpipeline: any) => {
        return azpipeline;
      }));
  }

  GetUnmappedItemList() {
    return this.http.get(`${this.environment.MappingManager}/unmappeditemgetlist`)
      .pipe(map((unmappeditemgetlist: any) => {
        return unmappeditemgetlist;
      }));
  }

}
